// extracted by mini-css-extract-plugin
export default {"container":"WorkSpace_container__KCs1d","workContainer":"WorkSpace_workContainer__8bJzM","chat":"WorkSpace_chat__ThkFV"};